import { Component, OnInit, Optional } from '@angular/core';
import { DynamicFormService } from '@ntap/common';
import {
  DataSource,
  ItemProvider,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ServerItemAction
} from '@ntap/core';
import { first, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-save-otprema-status-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class SaveOtpremaStatusAction
  extends ServerItemAction
  implements OnInit
{
  private saveOtpremaStatusActionName = 'saveStatusOtpremeForMoreOtpremas';

  constructor(
    protected override notificationService: NotificationService,
    @Optional() protected override itemProvider: ItemProvider,
    protected override dataSource: DataSource,
    @Optional()
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    protected dynamicFormService: DynamicFormService
  ) {
    super(notificationService, itemProvider, dataSource, listViewProvider);
  }
  ngOnInit(): void {
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selectedItems: any[]) => {
        return !selectedItems || selectedItems.length === 0;
      })
    );
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  override executeAction($event: any): void {
    if (this.dynamicFormService.formGroup.invalid) {
      throw new Error('Potrebno je odabrati status otpreme!');
    }
    this.listViewProvider.selectedItems$
      .pipe(
        first(),
        mergeMap((selectedItems: any[]) => {
          const selectedDostaveIds = selectedItems.map(
            (item) => item['seup~dostava~id']
          );
          const newOtpremaStatus =
            this.dynamicFormService.getFormValues()[
              'seup~dostava~otprema_status'
            ];
          const actionParams = {
            $selectedIds: selectedDostaveIds
          };
          (actionParams as any)['seup~dostava~otprema_status'] =
            newOtpremaStatus;
          return this.listViewProvider.executeAction(
            this.saveOtpremaStatusActionName,
            actionParams
          );
        })
      )
      .subscribe(() => {
        if (this.action.close_view && this.window) {
          this.window.close();
        }
        this.listViewProvider.refresh();
      });
  }
}
